export default "/_next/static/fonts/059f69d76ce8783a5d8a6aa1eaec5cfd.eot";